import "./App.css";
import { HashRouter, Routes, Route } from "react-router-dom";
import Layout from "./Layout";
import Main from "./pages/Main";
import { useState } from "react";
import Downloads from "./pages/Downloads";
import SpeciesPage from "./pages/SpeciesPage";
import Config from "./models/Config";

function App() {
  const [colorBg, setColorBg] = useState('bg-lime-900');
  const [logoHeader, setLogoHeader] = useState('/PlantViz_images/Asset_5.svg');
  const [showSpecies, setShowSpecies] = useState(true);

  const species = Object.keys(Config);

  return (
    <HashRouter>
      <Routes>
        <Route path="/" element={<Layout colorBg={colorBg} logoHeader={logoHeader} showSpecies={showSpecies} setShowSpecies={setShowSpecies} />}>
          <Route index element={<Main />} />
          {species.map((speciesName) => (
            <Route
              key={speciesName}
              path={Config[speciesName].url.substring(1)} // remove leading '/'
              element={
                <SpeciesPage
                  setColorBg={setColorBg}
                  setLogoHeader={setLogoHeader}
                  setShowSpecies={setShowSpecies}
                  speciesConfig={Config[speciesName]}
                />
              }
            />
          ))}
          <Route path="downloads" element={<Downloads />} />
        </Route>
      </Routes>
    </HashRouter>
  );
}

export default App;
